import { RefreshPayload } from "event-definitions"
import { noChange } from "lib/@hooks/useRefresh"
import { Bound } from "lib/@components/binding/Bound"
import { Box } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { KeepZeroU } from "./keep-zero-u"

export function ZeroU() {
    RefreshPayload.useRefresh(noChange)
    const { payloadTarget, target } = useBoundContext()
    if (!target.tasks) {
        return null
    }
    const task = (target.tasks[payloadTarget.id] ??= {})

    const period = task?.frequency?.period ?? payloadTarget.frequency?.period
    const interval = task?.frequency?.interval ?? payloadTarget.frequency?.interval
    return (
        (period === "Unknown" || interval === 0) && (
            <Bound target={task}>
                <Box data-cy="confirm-ou-checkbox">
                    <KeepZeroU />
                </Box>
            </Bound>
        )
    )
}
